import { ServiceConfig } from '@user/store/services/config'

type Option = {
  label: string
  value: string
}

export const ActivityStatusOptions: Option[] = [
  { label: 'To Do', value: 'Todo' },
  { label: 'In Progress', value: 'InProgress' },
  { label: 'Deferred', value: 'Deferred' },
  { label: 'Complete', value: 'Complete' },
]

export const getActivityUrl = `${ServiceConfig.baseAPIUrl}/${ServiceConfig.activities.activities}`
export const getActivityTypesUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.activityTypes.activityTypes}`
